"use client";

import * as React from "react";
import { cn } from "../../lib/utils";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  const innerRef = React.useRef<HTMLTextAreaElement>(null);

  // Merge forwarded ref with our local ref
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- we know it's defined
  React.useImperativeHandle(ref, () => innerRef.current!);

  // Resize handler
  const resize = React.useCallback(() => {
    const el = innerRef.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  }, []);

  // Update height on value change (helps with controlled components)
  React.useLayoutEffect(() => {
    resize();
  }, [props.value, resize]);

  return (
    <textarea
      className={cn(
        "flex min-h-[40px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className,
      )}
      onInput={(e) => {
        resize();
        props.onInput?.(e);
      }}
      ref={innerRef}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
